exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "fieldset {\r\n    margin-bottom: 20px !important;\r\n}\r\n\r\n    fieldset legend {\r\n        padding-bottom: 5px !important;\r\n        font-size: 15px !important;\r\n    }\r\n\r\n.input-group-addon {\r\n    padding: 0px 3px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/electricity/electricity-contract/electricity-contract.component.css
// module id = 661
// module chunks = 0